import styled from 'styled-components';
import { Badge } from '@elfsight/widget-ui';
import { createReadableClass, getColorWithAlpha } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { usePlayer } from '../../../player';

export function Status() {
  const { accentColor, playerParts } = useSettings();
  const { isLive } = usePlayer();

  const color = isLive ? accentColor : getColorWithAlpha(accentColor, 0.7);

  if (!playerParts.includes('status')) {
    return null;
  }

  return (
    <StyledBadge
      className={createReadableClass({
        component: 'radio-track-info',
        element: 'status',
        index: isLive ? 'live' : 'offline'
      })}
      size="small"
      color={color}
    >
      {isLive ? 'Live' : 'Offline'}
    </StyledBadge>
  );
}

const StyledBadge = styled(Badge)`
  overflow: visible;
`;
